import {CommonModule} from '@angular/common';
import {CUSTOM_ELEMENTS_SCHEMA, NgModule} from '@angular/core';
import {ReactiveFormsModule} from '@angular/forms';
import {RouterModule} from '@angular/router';
import {DcpAddToCartModule} from '@app/checkout/add-to-cart/dcp-add-to-cart.module';
import {AdditionalRequiredSolutionsButtonModule} from '@app/checkout/additional-required-solutions-button/additional-required-solutions-button.module';
import {GenericCallErrorModule} from '@app/checkout/error-handling/generic-call-error/generic-call-error.module';
import {FooterModule} from '@app/layout/footer/footer.module';
import {DynamicHeadingModule} from '@app/layout/header/dynamic-heading/dynamic-heading.module';
import {ConfiguratorComponentsModule} from '@app/product/configurator/configurator-components/configurator-components.module';
import {DerivativePricesComponent} from '@app/product/configurator/configurator-components/price-display/derivative-prices/derivative-prices.component';
import {PriceDisplayComponent} from '@app/product/configurator/configurator-components/price-display/price-display.component';
import {ConfigureServiceErrorModule} from '@app/product/configurator/error-handling/configure-service-error/configure-service-error.module';
import {AdditionalInformationModule} from '@app/product/configurator/notifications/additional-information.module';
import {ProductNameDisplayModule} from '@app/product/details/navigation-bar/product-name-display/product-name-display.module';
import {ContentLoadingIndicatorModule} from '@app/shared/content-loading-indicator/content-loading-indicator.module';
import {DeploymentSystemsModule} from '@app/shared/deployment-systems/deployment-systems.module';
import {DisposableMessageModule} from '@app/shared/disposable-message/disposable-message.module';
import {GroupSkipDirective} from '@dcp/accessibility';
import {
  DcpDateFormatterModule,
  LoadingIndicatorComponent,
  LoadingPageModule,
} from '@dcp/configurator';
import {NgbCollapseModule} from '@ng-bootstrap/ng-bootstrap';
import {FormlyModule} from '@ngx-formly/core';
import {I18nModule, UrlModule} from '@spartacus/core';
import {GenericLinkModule} from '@spartacus/storefront';
import {
  AccordionModule,
  CheckboxModule,
  InputModule,
  RadioGroupModule,
  SwitchModule,
  TooltipModule,
} from 'ng-design-system';
import {EditCartEntryComponent} from './edit-cart-entry/edit-cart-entry.component';
import {EditCartPageComponent} from './edit-cart-page/edit-cart-page.component';

@NgModule({
  declarations: [
    EditCartEntryComponent,
    EditCartPageComponent,
    PriceDisplayComponent,
    DerivativePricesComponent,
  ],
  imports: [
    CommonModule,
    I18nModule,
    RouterModule,
    DcpAddToCartModule,
    ProductNameDisplayModule,
    ConfiguratorComponentsModule,
    UrlModule,
    ReactiveFormsModule,
    FormlyModule,
    DynamicHeadingModule,
    FooterModule,
    DisposableMessageModule,
    ConfigureServiceErrorModule,
    DeploymentSystemsModule,
    SwitchModule,
    RadioGroupModule,
    AccordionModule,
    NgbCollapseModule,
    InputModule,
    CheckboxModule,
    GenericLinkModule,
    GenericCallErrorModule,
    AdditionalInformationModule,
    ContentLoadingIndicatorModule,
    TooltipModule,
    AdditionalRequiredSolutionsButtonModule,
    DcpDateFormatterModule,
    LoadingIndicatorComponent,
    LoadingPageModule,
    GroupSkipDirective,
  ],
  exports: [EditCartEntryComponent, EditCartPageComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class CartEditModule {}
